// FETCH ALL IRONING_PACKING INWARD DETAILS
export const FETCH_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK = 'FETCH_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK = 'FETCH_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL IRONING_PACKING INWARD DETAILS
export const FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_IRONING_PACKING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK';

// CREATE IRONING_PACKING INWARD DETAILS
export const CREATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK = 'CREATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK';
export const CREATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK = 'CREATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK = 'CREATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK';

// UPDATE IRONING_PACKING INWARD DETAILS
export const UPDATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK = 'UPDATE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK = 'UPDATE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF IRONING_PACKING INWARD DETAILS
export const FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM IRONING_PACKING_INWARD DETAILS
export const FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK';

// DELETE IRONING_PACKING INWARD DETAILS
export const DELETE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK = 'DELETE_IRONING_PACKING_INWARD_DETAILS_REQUEST_DK';
export const DELETE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK = 'DELETE_IRONING_PACKING_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK = 'DELETE_IRONING_PACKING_INWARD_DETAILS_FAILURE_DK';

export const RESET_IRONING_PACKING_INWARD_DETAILS_INFO_DK = 'RESET_IRONING_PACKING_INWARD_DETAILS_INFO_DK';

export const CREATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK = 'CREATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK';

export const UPDATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK = 'UPDATE_IRONING_PACKING_INWARD_DETAILS_FORM_DK';
